import { DeeplinkKeys } from '@/consts/deepLinks';
import { getContext } from '@/context';

import { DeeplinkKind } from './types';

/**
 * Module-private URL mutator. Only the DeeplinkRouter should call this.
 * External consumers must never touch the URL — they receive a parsed
 * deeplink from the snapshot and let the router strip it after their
 * handler resolves.
 */
const KIND_TO_KEY: Record<
  Exclude<DeeplinkKind, DeeplinkKind.None>,
  DeeplinkKeys
> = {
  [DeeplinkKind.Task]: DeeplinkKeys.taskId,
  [DeeplinkKind.ProjectJson]: DeeplinkKeys.presetJsonUrl,
  [DeeplinkKind.Preset]: DeeplinkKeys.presetId,
  [DeeplinkKind.Category]: DeeplinkKeys.category,
};

export const stripDeeplinkUrl = (kind: DeeplinkKind): void => {
  if (kind === DeeplinkKind.None) return;
  const key = KIND_TO_KEY[kind];
  try {
    const { params, route } = getContext().general.location.getState();
    if (!params[key]) return;
    const { [key]: _, ...remainingParams } = params;
    getContext().general.location.dispatch({
      route,
      params: remainingParams,
    });
  } catch {
    // SDK unavailable — URL mutation is best-effort
  }
};
